/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { observable, action } from 'mobx';

export default class Progress {
    @observable inProgress;

    @observable isWaiting;

    @observable percentage;

    @observable localizedMessageText;

    @observable isCancellable;

    @observable status;

    actionInProgress;

    @action setInProgress(inProgress) {
        this.inProgress = inProgress;
    }

    @action setPercentage(number) {
        this.percentage = number;
    }

    @action setIsWaiting(isWaiting) {
        this.isWaiting = isWaiting;
    }

    @action setIsCancellable(isCancellable) {
        this.isCancellable = isCancellable;
    }

    @action setLocalizedMessageText(text) {
        this.localizedMessageText = text;
    }

    @action setStatus(status) {
        this.status = status;
    }

    constructor({
        inProgress, isWaiting, percentage,
        localizedMessageText, isCancellable,
        actionInProgress, status,
    }) {
        this.inProgress = inProgress;
        this.isWaiting = isWaiting;
        this.percentage = percentage;
        this.localizedMessageText = localizedMessageText;
        this.isCancellable = isCancellable;
        this.actionInProgress = actionInProgress;
        this.status = status;
    }
}
